import React from 'react';
import { Frame } from './Frame';
import { Logo } from './Logo';
import { Link } from 'react-router-dom';
import { navLinks } from '../data/navigation';
import { legalPages } from '../data/legal';
import { OPEN_COOKIE_SETTINGS } from './CookieBanner';
import { LinkedInIcon, MailFilledIcon, WhatsAppIcon } from './SocialIcons';
import { contact } from '../data/contact';
const PHONE_DISPLAY = '+49 157 73491110';
const socials = [{
  label: 'WhatsApp',
  href: `https://wa.me/${contact.whatsappNumber}`,
  Icon: WhatsAppIcon,
  external: true
}, {
  label: 'LinkedIn',
  href: contact.linkedinUrl,
  Icon: LinkedInIcon,
  external: true
}, {
  label: 'E-Mail',
  href: `mailto:${contact.email}`,
  Icon: MailFilledIcon,
  external: false
}];
export function Footer() {
  return <footer className="bg-white" data-id="element-196" data-mp="3qf9nsguoakcm">
      <Frame data-id="element-197" data-mp="29yxcxcohlklt">
        <div className="grid gap-10 px-5 py-14 sm:grid-cols-2 md:grid-cols-[minmax(0,1.6fr)_1.2fr_1fr_1fr] md:px-6" data-id="element-198" data-mp="29ydvdx2r0y8b">
          <div data-id="element-199" data-mp="2ezurlfaafwik">
            <p className="max-w-[340px] text-[15px] leading-relaxed text-ink/70" data-id="element-200" data-mp="2ew70emsbfm70">
              CAD-Konstruktion und technische Produktentwicklung für Maschinenbau, Anlagenbau und technische
              Produkte.
            </p>
            <ul className="mt-6 flex items-center gap-2" aria-label="Soziale Kanäle" data-id="element-201" data-mp="3v7gbtq7xxs4j">
              {socials.map(({
              label,
              href,
              Icon,
              external
            }) => <li key={label} data-id="element-202" data-mp="3q7bxa5qlf7gy">
                  <a href={href} aria-label={label} {...external ? {
                target: '_blank',
                rel: 'noopener noreferrer'
              } : {}} className="grid h-10 w-10 place-items-center rounded-full bg-canvas text-ink/70 transition-colors duration-150 hover:bg-ink hover:text-white" data-id="element-203" data-mp="82qsbsqetttq">
                    <Icon className="h-[18px] w-[18px]" data-id="element-204" data-mp="cuii411qrvit" />
                  </a>
                </li>)}
            </ul>
          </div>
          <address className="not-italic" data-id="element-205" data-mp="msg74qrfdwch">
            <h2 className="font-mono text-[11px] uppercase tracking-[0.12em] text-muted" data-id="element-206" data-mp="mtrbossp384n">Kontakt</h2>
            <ul className="mt-4 space-y-2.5 text-[15px] text-ink" data-id="element-207" data-mp="twxv9kvlbuel">
              <li data-id="element-208" data-mp="yv93xsa5fyv8">Konrad Walz</li>
              <li className="text-ink/70" data-id="element-209" data-mp="yuh6sd0wlt2u">
                Klingenstraße 5
                <br data-id="element-210" data-mp="13siq8z28rueu" />
                73491 Neuler, Deutschland
              </li>
              <li data-id="element-211" data-mp="18k92jakqos8w">
                <a href={`tel:+${contact.whatsappNumber}`} className="transition-colors duration-150 hover:text-ink/55" data-id="element-212" data-mp="18ksnl05orwr5">
                  {PHONE_DISPLAY}
                </a>
              </li>
              <li data-id="element-213" data-mp="1hje30mfv2vnp">
                <a href={`mailto:${contact.email}`} className="break-all transition-colors duration-150 hover:text-ink/55" data-id="element-214" data-mp="1hiukb3ie038m">
                  {contact.email}
                </a>
              </li>
            </ul>
          </address>
          <nav aria-label="Fußzeile" data-id="element-215" data-mp="3ob551yhw6t30">
            <h2 className="font-mono text-[11px] uppercase tracking-[0.12em] text-muted" data-id="element-216" data-mp="3oc6q8vsmgvyg">Seite</h2>
            <ul className="mt-4 space-y-2.5" data-id="element-217" data-mp="3tb9kdl72dhrn">
              {navLinks.map(link => <li key={link.href} data-id="element-218" data-mp="2afdhlagc14nq">
                  <a href={link.href} className="text-[15px] text-ink transition-colors duration-150 hover:text-ink/55" data-id="element-219" data-mp="2ageulkgws183">
                    {link.label}
                  </a>
                </li>)}
            </ul>
          </nav>
          <div data-id="element-220" data-mp="1wnz05822pbis">
            <h2 className="font-mono text-[11px] uppercase tracking-[0.12em] text-muted" data-id="element-221" data-mp="1woi7juu3khik">Rechtliches</h2>
            <ul className="mt-4 space-y-2.5" data-id="element-222" data-mp="2tcy8so6kkfbi">
              {legalPages.map(page => <li key={page.slug} data-id="element-223" data-mp="2pc4k3slaywhk">
                  <Link to={`/${page.slug}`} className="text-[15px] text-ink transition-colors duration-150 hover:text-ink/55" data-id="element-224" data-mp="2pd5wc0e21p0v">
                    {page.label}
                  </Link>
                </li>)}
              <li data-id="element-225" data-mp="2fgkpd9ih63ue">
                <button type="button" onClick={() => window.dispatchEvent(new Event(OPEN_COOKIE_SETTINGS))} className="text-[15px] text-ink transition-colors duration-150 hover:text-ink/55" data-id="element-226" data-mp="18xuyv7ccxnuy">
                  Cookie-Einstellungen
                </button>
              </li>
            </ul>
          </div>
        </div>
        <div className="overflow-hidden border-t border-line px-5 pt-8 md:px-6" data-id="element-227" data-mp="2iv1herwpls9j">
          <Logo className="block text-[22vw] leading-[0.78] text-ink md:text-[150px] lg:text-[230px]" data-id="element-228" data-mp="2isyifidkwoso" />
        </div>
        <div className="flex flex-col gap-2 border-t border-line px-5 py-5 font-mono text-[11px] uppercase tracking-[0.12em] text-muted sm:flex-row sm:justify-between md:px-6" data-id="element-229" data-mp="3bjqhqopxxtk8">
          <span data-id="element-230" data-mp="3fj7orml0myri">© 2026 Konrad Walz</span>
          <span data-id="element-231" data-mp="31m2d972j97ov">konradwalz.com</span>
        </div>
      </Frame>
    </footer>;
}